import Products from 'shared-assets/lib/sdk/products';

angular.module('kareo.ui.shared.modules.product-setup', ['kareo.ui.shared.modules.featureSet', 'kareo.ui.shared.modules.api.k-product-setup-service']).provider('ProductSetup', [
  function () {
    this.$get = ['$window', 'featureSet', 'kProductSetupService', function ($window, featureSet, kProductSetupService) {
      var PRODUCT_SETUP_URL = '/product-setup-ui/#/product-setup-wizard';

      function goToSetup() {
        $window.location = PRODUCT_SETUP_URL;
      }

      function isProductSetupRequired() {
        return featureSet.load()
            .then((features) => {
              if (!!features['dark-feature.signup-full-order-provision']) {
                isPracticeSetupRequired();
              } else {
                isOldProductSetupRequired();
              }
            });
      }

      function isPracticeSetupRequired() {
        const currentAccountIds = sessionStorage.getItem('currentAccountIds');
        const practiceSetupRequiredKey = 'practiceSetupRequired' + (currentAccountIds || '');
        if (sessionStorage.getItem(practiceSetupRequiredKey) !== 'false') {
          Products.getPracticeSetupState().then((practiceSetupState) => {
            if (practiceSetupState?.setupState) { // if practiceSetupState is not null, it means that the practiceSetup has a record in the DB
              if(practiceSetupState.setupState !== 'Done') {
                goToSetup();
              } else {
                sessionStorage.setItem(practiceSetupRequiredKey, 'false');
              }
            } else {
              // if practiceSetup has no record in the DB we should fallback to the old way of checking if the user needs to go to the product setup
              isProductSetupRequiredFallBack(practiceSetupRequiredKey); 
            }
          });
        }       
      }

      function isProductSetupRequiredFallBack(practiceSetupRequiredKey) {
        getCheckRequireProductSetup().then((response) => {
          if (response) {
            // If the practiceSetup was not completed we need to go to setup
            goToSetup();
          } else {
            // If the practiceSetup was completed we need to save the value in the new practiceSetupState as 'Done' and update the sessionStorage
            Products.upsertPracticeSetupState('Done').then(() => {
              sessionStorage.setItem(practiceSetupRequiredKey, 'false');
            });
          }
        });
      }

      function getCheckRequireProductSetup() {
        if (sessionStorage.getItem('setupCheckRequired') !== 'false') {
          return kProductSetupService.checkRequireProductSetup();
        }
        return false;
      }

      function isOldProductSetupRequired() {
        // This should not longer be the way of verifying if the user needs to go to the product setup
        // After dark-feature.signup-full-order-provision graduation, the isPracticeSetupRequired should be used
        if (sessionStorage.getItem('setupCheckRequired') !== 'false') {
          kProductSetupService.checkRequireProductSetup().then((response) => {
            if (response) {
              goToSetup();
            } else {
              sessionStorage.setItem('setupCheckRequired', 'false');
            }
          });
        }     
      }

      var service = {
        isProductSetupRequired
      };
      return service;
    }];
  }]);
